/* High Class theme — theme.js */
(function () {
  'use strict';

  const T = window.theme || { routes: {}, strings: {}, delivery: {} };
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = format || T.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    let value = '';
    const match = fmt.match(placeholderRegex);
    const type = match ? match[1] : 'amount';
    switch (type) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.theme.formatMoney = formatMoney;

  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  function lockScroll(lock) { document.body.classList.toggle('overflow-hidden', !!lock); }

  function trapFocus(container) {
    const focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container).filter(el => el.offsetParent !== null);
    if (focusables.length) focusables[0].focus({ preventScroll: true });
  }

  /* ---------- header ---------- */
  const headerWrapper = $('.header-wrapper');
  if (headerWrapper) {
    const onScroll = () => headerWrapper.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const setHeaderHeight = () => document.documentElement.style.setProperty('--header-height', headerWrapper.offsetHeight + 'px');
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  }

  /* ---------- drawers ---------- */
  const Drawers = {
    open(id) {
      const d = document.getElementById(id);
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      setTimeout(() => trapFocus(d), 200);
    },
    close(d) {
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      if (!$('.drawer.is-open')) lockScroll(false);
    },
    closeAll() { $$('.drawer.is-open').forEach(d => Drawers.close(d)); lockScroll(false); }
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault();
      Drawers.open(id);
      return;
    }
    const closer = e.target.closest('[data-drawer-close], .drawer__overlay');
    if (closer) { e.preventDefault(); Drawers.close(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { Drawers.closeAll(); SearchModal.close(); Lightbox.close(); }
  });

  /* ---------- search modal ---------- */
  const SearchModal = {
    el: $('#SearchModal'),
    open() { if (!this.el) return; this.el.classList.add('is-open'); lockScroll(true); const i = $('input[type="search"]', this.el); if (i) setTimeout(() => i.focus(), 50); },
    close() { if (!this.el || !this.el.classList.contains('is-open')) return; this.el.classList.remove('is-open'); if (!$('.drawer.is-open')) lockScroll(false); }
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); SearchModal.open(); }
    if (e.target.closest('[data-search-close], .search-modal__overlay')) { e.preventDefault(); SearchModal.close(); }
  });
  (function predictive() {
    const modal = SearchModal.el; if (!modal) return;
    const input = $('input[type="search"]', modal);
    const results = $('[data-predictive-results]', modal);
    if (!input || !results || !T.routes.predictiveSearch) return;
    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.classList.remove('has-results'); results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
          const res = await fetch(url, { signal: controller.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('#shopify-section-predictive-search', doc);
          results.innerHTML = inner ? inner.innerHTML : '';
          results.classList.toggle('has-results', !!results.textContent.trim());
        } catch (err) { /* ignore */ }
      }, 250);
    });
  })();

  /* ---------- cart ---------- */
  const Cart = {
    sectionsToRender() {
      const ids = [];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      if ($('[data-cart-page]')) ids.push('main-cart');
      return ids;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) { const err = new Error(data.description || data.message || T.strings.cartError); err.data = data; throw err; }
      return data;
    },
    async add(formData) {
      const body = {};
      formData.forEach((v, k) => {
        if (k.startsWith('properties[')) { body.properties = body.properties || {}; body.properties[k.slice(11, -1)] = v; }
        else body[k] = v;
      });
      body.quantity = parseInt(body.quantity || '1', 10) || 1;
      body.sections = this.sectionsToRender().join(',');
      body.sections_url = window.location.pathname;
      const data = await this.request(T.routes.cartAdd + '.js', body);
      this.renderSections(data.sections);
      await this.refreshCount();
      return data;
    },
    async change(line, quantity) {
      const drawer = $('#CartDrawer');
      if (drawer) drawer.classList.add('is-loading');
      try {
        const data = await this.request(T.routes.cartChange + '.js', { line, quantity, sections: this.sectionsToRender().join(','), sections_url: window.location.pathname });
        this.renderSections(data.sections);
        this.updateCount(data.item_count);
        return data;
      } finally { if (drawer) drawer.classList.remove('is-loading'); }
    },
    async updateNote(note) {
      try { await this.request(T.routes.cartUpdate + '.js', { note }); } catch (e) { /* ignore */ }
    },
    renderSections(sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = $('[data-cart-drawer-content]', doc);
        const current = $('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      if (sections['main-cart']) {
        const doc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
        const fresh = $('[data-cart-page]', doc);
        const current = $('[data-cart-page]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
    },
    updateCount(n) {
      $$('[data-cart-count]').forEach(el => { el.textContent = n; el.setAttribute('data-count', n); });
    },
    async refreshCount() {
      try { const res = await fetch(T.routes.cart + '.js'); const c = await res.json(); this.updateCount(c.item_count); } catch (e) { /* ignore */ }
    }
  };
  window.theme.cart = Cart;

  // quantity buttons (product form + cart)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest('.quantity');
    const input = $('input', wrap);
    if (!input) return;
    const step = parseInt(input.step || '1', 10) || 1;
    const min = parseInt(input.min || '1', 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let val = parseInt(input.value || '1', 10) || 1;
    val = btn.getAttribute('data-qty-change') === 'plus' ? val + step : val - step;
    val = Math.max(min, Math.min(max, val));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // cart line changes
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-quantity]');
    if (!input) return;
    const line = parseInt(input.getAttribute('data-line-quantity'), 10);
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    Cart.change(line, qty).catch(err => {
      const errEl = $(`[data-line-error="${line}"]`);
      if (errEl) { errEl.textContent = err.message; errEl.classList.add('is-visible'); }
      else toast(err.message);
    });
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    Cart.change(parseInt(rm.getAttribute('data-line-remove'), 10), 0).catch(err => toast(err.message));
  });
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) Cart.updateNote(note.value);
  });

  // product forms (AJAX add to cart)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.product-form');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const errEl = $('[data-form-error]', form.closest('[data-product-section]') || form);
    if (errEl) { errEl.classList.remove('is-visible'); errEl.textContent = ''; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    const fd = new FormData(form);
    Cart.add(fd).then(() => {
      if (T.cartType === 'drawer' && $('#CartDrawer')) Drawers.open('CartDrawer');
      else window.location.href = T.routes.cart;
    }).catch(err => {
      if (errEl) { errEl.textContent = err.message; errEl.classList.add('is-visible'); } else toast(err.message);
    }).finally(() => {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    });
  });

  // quick add from cards
  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    const id = qa.getAttribute('data-quick-add');
    qa.classList.add('is-loading');
    const fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
    Cart.add(fd).then(() => {
      if (T.cartType === 'drawer' && $('#CartDrawer')) Drawers.open('CartDrawer'); else window.location.href = T.routes.cart;
    }).catch(err => toast(err.message)).finally(() => qa.classList.remove('is-loading'));
  });

  /* ---------- variants ---------- */
  $$('[data-product-section]').forEach(section => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const form = $('form.product-form', section);
    const idInput = form ? $('input[name="id"]', form) : null;
    const priceEl = $('[data-price]', section);
    const button = form ? $('[type="submit"]', form) : null;
    const buttonText = button ? $('[data-button-text]', button) || button : null;
    const stickyPrice = $('[data-sticky-price]', section);
    const picker = $('[data-variant-picker]', section);
    const skuEl = $('[data-sku]', section);
    const gallery = $('[data-gallery]', section);

    function selectedOptions() {
      if (!picker) return null;
      const opts = [];
      $$('[data-option-index]', picker).forEach(group => {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        const checked = $('input:checked', group) || $('select', group);
        opts[idx] = checked ? checked.value : null;
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    function renderPrice(v) {
      if (!priceEl) return;
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      let html = '';
      if (onSale) html += `<span class="price__compare">${formatMoney(v.compare_at_price)}</span><span class="price__sale">${formatMoney(v.price)}</span>`;
      else html += `<span class="price__regular">${formatMoney(v.price)}</span>`;
      priceEl.innerHTML = html;
      priceEl.classList.toggle('price--on-sale', !!onSale);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    }
    function updateAvailability(opts) {
      if (!picker) return;
      $$('[data-option-index]', picker).forEach(group => {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        $$('input', group).forEach(input => {
          const test = opts.slice(); test[idx] = input.value;
          const v = product.variants.find(x => x.options.every((o, i) => i === idx ? o === input.value : (test[i] == null || o === test[i])));
          input.classList.toggle('is-unavailable', !(v && v.available));
        });
      });
    }
    function apply(v) {
      if (!v) {
        if (button) { button.disabled = true; if (buttonText) buttonText.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      renderPrice(v);
      if (button) {
        button.disabled = !v.available;
        if (buttonText) buttonText.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (v.featured_media && gallery) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, gallery);
        if (slide) Gallery.goTo(gallery, slide);
      }
      if (window.history && window.history.replaceState && product.variants.length > 1) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      $$('[data-option-index]', picker || section).forEach(group => {
        const label = $('[data-selected-value]', group);
        const checked = $('input:checked', group);
        if (label && checked) label.textContent = checked.value;
      });
    }
    if (picker) {
      picker.addEventListener('change', () => { const opts = selectedOptions(); updateAvailability(opts); apply(findVariant(opts)); });
      updateAvailability(selectedOptions());
    }
  });

  /* ---------- gallery ---------- */
  const Gallery = {
    goTo(gallery, slide) {
      const slides = $('[data-slides]', gallery);
      if (!slides || !slide) return;
      slides.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    },
    init(gallery) {
      const slides = $('[data-slides]', gallery);
      const items = $$('[data-media-id]', slides);
      const thumbs = $$('[data-thumb]', gallery);
      const dots = $$('[data-dot]', gallery);
      if (!slides || !items.length) return;
      const setActive = (i) => {
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        gallery.setAttribute('data-active', i);
      };
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => { if (en.isIntersecting && en.intersectionRatio >= 0.6) setActive(items.indexOf(en.target)); });
      }, { root: slides, threshold: [0.6] });
      items.forEach(it => io.observe(it));
      thumbs.forEach((t, i) => t.addEventListener('click', () => Gallery.goTo(gallery, items[i])));
      dots.forEach((d, i) => d.addEventListener('click', () => Gallery.goTo(gallery, items[i])));
      setActive(0);
      // zoom / lightbox
      const images = items.map(it => { const img = $('img', it); return img ? { src: img.getAttribute('data-full') || img.currentSrc || img.src, alt: img.alt } : null; }).filter(Boolean);
      gallery.addEventListener('click', (e) => {
        const zoomBtn = e.target.closest('[data-zoom]');
        const img = e.target.closest('[data-media-id] img');
        if (!zoomBtn && !img) return;
        const idx = parseInt(gallery.getAttribute('data-active') || '0', 10);
        Lightbox.open(images, idx);
      });
    }
  };
  $$('[data-gallery]').forEach(g => Gallery.init(g));

  /* ---------- lightbox ---------- */
  const Lightbox = {
    el: $('#Lightbox'), images: [], idx: 0,
    open(images, idx) {
      if (!this.el || !images.length) return;
      this.images = images; this.idx = idx || 0;
      this.render();
      this.el.classList.add('is-open'); lockScroll(true);
    },
    close() { if (!this.el || !this.el.classList.contains('is-open')) return; this.el.classList.remove('is-open'); if (!$('.drawer.is-open')) lockScroll(false); },
    render() { const img = $('img', this.el); const cur = this.images[this.idx]; if (img && cur) { img.src = cur.src; img.alt = cur.alt || ''; } $$('.lightbox__nav', this.el).forEach(n => n.style.display = this.images.length > 1 ? '' : 'none'); },
    next() { this.idx = (this.idx + 1) % this.images.length; this.render(); },
    prev() { this.idx = (this.idx - 1 + this.images.length) % this.images.length; this.render(); }
  };
  if (Lightbox.el) {
    Lightbox.el.addEventListener('click', (e) => {
      if (e.target.closest('[data-lightbox-close]') || e.target === Lightbox.el) Lightbox.close();
      if (e.target.closest('[data-lightbox-next]')) Lightbox.next();
      if (e.target.closest('[data-lightbox-prev]')) Lightbox.prev();
    });
    document.addEventListener('keydown', (e) => {
      if (!Lightbox.el.classList.contains('is-open')) return;
      if (e.key === 'ArrowRight') Lightbox.next();
      if (e.key === 'ArrowLeft') Lightbox.prev();
    });
  }

  /* ---------- delivery estimate (estilo Mercado Libre) ---------- */
  (function delivery() {
    const els = $$('[data-delivery]');
    if (!els.length || !T.delivery || !T.delivery.enabled) return;
    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    function nowInMexico() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
        const get = t => parseInt(parts.find(p => p.type === t).value, 10);
        return { date: new Date(get('year'), get('month') - 1, get('day')), hour: get('hour') % 24 };
      } catch (e) { const d = new Date(); return { date: new Date(d.getFullYear(), d.getMonth(), d.getDate()), hour: d.getHours() }; }
    }
    function addBusinessDays(date, n) {
      const d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function nextBusinessDay(d) { const s = new Date(d); do { s.setDate(s.getDate() + 1); } while (s.getDay() === 0 || s.getDay() === 6); return s; }
    const { date, hour } = nowInMexico();
    let start = new Date(date);
    const isWeekend = start.getDay() === 0 || start.getDay() === 6;
    if (isWeekend || hour >= (T.delivery.cutoffHour || 13)) start = nextBusinessDay(start);
    if (T.delivery.processingDays) start = addBusinessDays(start, T.delivery.processingDays);
    const min = addBusinessDays(start, Math.max(1, T.delivery.minDays || 1));
    const max = addBusinessDays(start, Math.max(T.delivery.minDays || 1, T.delivery.maxDays || 3));
    const fmt = (d, withMonth) => `${days[d.getDay()]} ${d.getDate()}${withMonth ? ' de ' + months[d.getMonth()] : ''}`;
    let text;
    if (min.getMonth() === max.getMonth()) text = (T.delivery.templateSameMonth || 'Llega entre el {{min}} y el {{max}}').replace(/\{\{\s*min\s*\}\}/g, fmt(min, false)).replace(/\{\{\s*max\s*\}\}/g, fmt(max, true));
    else text = (T.delivery.template || 'Llega entre el {{min}} y el {{max}}').replace(/\{\{\s*min\s*\}\}/g, fmt(min, true)).replace(/\{\{\s*max\s*\}\}/g, fmt(max, true));
    els.forEach(el => { const t = $('[data-delivery-text]', el) || el; t.textContent = text; el.classList.add('is-ready'); });
  })();

  /* ---------- sticky add to cart (mobile) ---------- */
  (function sticky() {
    const bar = $('[data-sticky-atc]');
    const anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(anchor);
    const btn = $('[data-sticky-submit]', bar);
    if (btn) btn.addEventListener('click', () => { const form = $('form.product-form'); if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
  })();

  /* ---------- product details tabs ---------- */
  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[data-tab]', tabs);
    const panels = $$('[data-tab-panel]', tabs);
    buttons.forEach(b => b.addEventListener('click', () => {
      const id = b.getAttribute('data-tab');
      buttons.forEach(x => x.classList.toggle('is-active', x === b));
      panels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id));
    }));
  });

  /* ---------- collection sorting ---------- */
  $$('[data-sort-by]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    const pid = el.getAttribute('data-product-id');
    const sectionId = el.getAttribute('data-section-id');
    const limit = el.getAttribute('data-limit') || 4;
    if (!pid || !T.routes.recommendations) return;
    try {
      const res = await fetch(`${T.routes.recommendations}?section_id=${sectionId}&product_id=${pid}&limit=${limit}&intent=related`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.classList.add('is-loaded'); }
      else if (!el.querySelector('.product-card')) el.closest('.related') && (el.closest('.related').style.display = 'none');
    } catch (e) { /* ignore */ }
  });

  /* ---------- share ---------- */
  document.addEventListener('click', async (e) => {
    const s = e.target.closest('[data-share]');
    if (!s) return;
    e.preventDefault();
    const data = { title: document.title, url: window.location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (err) { /* cancelled */ } }
    else { try { await navigator.clipboard.writeText(data.url); toast(s.getAttribute('data-share-copied') || 'Link copiado'); } catch (err) { /* ignore */ } }
  });

  /* ---------- initial cart count ---------- */
  Cart.refreshCount();

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener('shopify:section:load', () => { $$('[data-gallery]').forEach(g => Gallery.init(g)); });
})();
